import React, {useEffect} from 'react';
import {Card} from "react-bootstrap";
import {Button, Select} from "antd";
import {Controller, useForm} from "react-hook-form";
import {columnAlignmentOptions, columnTypeOptions, pipeArgOptions} from "./TableConfigStaticSelectOptions";
import {useDispatch, useSelector} from "react-redux";
import {uniqueDeviceTypes} from "../../redux-store/selectors";
import {setTableColumnNewState} from "../../redux-store/dynamicTable";
import {displayNotification} from "../../redux-store/notification";
import DeleteColumnButton from "./DeleteColumnButton";
import ErrorIcon from "../../images/errorIcon.png";
import {REQUIRED_FIELD} from "../../constants/Messages";

const {Option} = Select

function TableColumnConfig(props) {

    const {id, tableid, col} = props

    const dispatch = useDispatch()

    const {uniqueReadableParams, uniqueCommandProducers} = useSelector(uniqueDeviceTypes)

    const {
        handleSubmit, register, control, watch, setValue, formState: {errors},
    } = useForm()

    const watchType = watch("type")

    useEffect(()=>{
        setValue("type",col.type)
    },[])

    useEffect(() => {
        if (watchType === "DATA") {
            setValue("alignment", col.alignment)
            setValue("pipe", col.pipe)
            setValue("parameterName", col.parameterName)
        } else if (watchType === "COMMAND") {
            setValue("methodName", col.methodName)
            setValue("arguments", col.arguments ? JSON.stringify(col.arguments).slice(1, -1) : "")
        }
    }, [watchType])

    const submitCol = (data) => {
        data.id = id

        if (data.type === "DATA") {
            data.methodName = null
            data.arguments = null
        } else if (data.type === "COMMAND") {
            data.parameterName = null
            data.pipe = null;
            data.pipeArg = null;
            data.alignment = "CENTER";
            if (data.arguments) data.arguments = JSON.parse('[' + data.arguments + ']');
            else data.arguments = [];
        }

        dispatch(setTableColumnNewState({tableid, id, data}))
        dispatch(displayNotification({
            notificationStatus: "info",
            message: "Sačuvane privremene izmjene",
            title: "Tabele"
        }))
    }

    return (<Card {...props} style={{width: "200px"}}>
        <form onSubmit={handleSubmit(submitCol)}>
            <Card.Header>
                <div className={"row"}>
                    <div className={"col-6"}><Button htmlType="submit" className={"btn-save-antd"}>Sačuvaj</Button>
                    </div>
                    <div className={"col-6"}><DeleteColumnButton id={id} tableId={tableid}/></div>
                </div>
                <span className={"device-accordion-title"}>
                <input type="text"
                       className="form-control"
                       defaultValue={col.title}
                       {...register("title")}/>
            </span>
            </Card.Header>
            <Card.Body>
                <input type="text"
                       className="form-control mb-2"
                       defaultValue={col.description}
                       {...register("description")}/>

                <Controller
                    control={control}
                    name={"type"}
                    render={({
                                 field: {onChange, value, ref},
                             }) => (<Select
                        onChange={onChange}
                        value={value}
                        ref={ref}
                        className={"form-select mb-2"}
                    >
                        {columnTypeOptions.map((item, index) => {
                            return (<Option key={index} value={item.value}>{item.label}</Option>)
                        })}
                    </Select>)}
                />

                {watchType === "DATA" ?
                    <>
                        <Controller
                            control={control}
                            name={"parameterName"}
                            rules={{required: REQUIRED_FIELD}}
                            render={({
                                         field: {onChange, value, ref},
                                     }) => (<Select
                                onChange={onChange}
                                value={value}
                                ref={ref}
                                className={"form-select mb-2"}
                                showSearch
                            >
                                {uniqueReadableParams.map((item, index) => {
                                    return (<Option key={index} value={item}>{item}</Option>)
                                })}
                            </Select>)}
                        />
                        {errors.parameterName && (
                            <span className="loggin-error"><img
                                src={ErrorIcon}/> {errors.parameterName.message}</span>
                        )}

                        <Controller
                            control={control}
                            name={"alignment"}
                            render={({
                                         field: {onChange, value, ref},
                                     }) => (<Select
                                onChange={onChange}
                                value={value}
                                ref={ref}
                                className={"form-select mb-2"}
                            >
                                {columnAlignmentOptions.map((item, index) => {
                                    return (<Option key={index} value={item.value}>{item.label}</Option>)
                                })}
                            </Select>)}
                        />

                        <Controller
                            control={control}
                            name={"pipe"}
                            render={({
                                         field: {onChange, value, ref},
                                     }) => (<Select
                                onChange={onChange}
                                value={value}
                                ref={ref}
                                allowClear
                                className={"form-select mb-2"}
                            >
                                {pipeArgOptions.map((item, index) => {
                                    return (<Option key={index} value={item.value}>{item.label}</Option>)
                                })}
                            </Select>)}
                        />
                        <input type="text"
                               className="form-control"
                               defaultValue={col.pipeArg}
                               {...register("pipeArg")}/>
                    </>

                    : <>

                        <Controller
                            control={control}
                            name={"methodName"}
                            rules={{required: REQUIRED_FIELD}}
                            render={({
                                         field: {onChange, value, ref},
                                     }) => (<Select
                                className={"form-select mb-2"}
                                showSearch
                                onChange={onChange}
                                value={value}
                                ref={ref}
                                getPopupContainer={node => node.parentNode}
                            >
                                {uniqueCommandProducers.map((item, index) => {
                                    return (<Option key={index} value={item}>{item}</Option>)
                                })}
                            </Select>)}
                        />
                        {errors.methodName && (
                            <span className="loggin-error"><img
                                src={ErrorIcon}/> {errors.methodName.message}</span>
                        )}

                        <input type="text"
                               className="form-control mb-2"
                               {...register("arguments")}/>

                    </>}
            </Card.Body>
        </form>
    </Card>);
}

export default TableColumnConfig;
